<template>
  <div
    v-if="supervision.id"
    :class="[$style.description, { [$style.open]: isOpen }]"
  >
    <div
      :class="[$style.top, { [$style.active]: isDown }]"
      ref="scrollContainer"
      @mousedown="startDrag"
      @mouseleave="stopDrag"
      @mouseup="stopDrag"
      @mousemove="doDrag"
      @click.capture="handleClick"
    >
      <div :class="$style.left">
        <div>Время начала (план/факт)</div>
        <div>Время окончания (план/факт)</div>
        <div>Трудовая операция</div>
        <div>Длительность (план/факт)</div>
        <div>Фото</div>
        <div>Комментарий наблюдателя</div>
        <div>Комментарий администратора</div>
      </div>
      <ActivityCard
        v-for="activity in supervision.analytics"
        :key="activity.id"
        :activity="activity"
        @setVerified="$emit('setVerifiedItem', $event)"
        @openModal="$emit('openModal', $event)"
        @openImage="(comment, image) => $emit('openImage', comment, image)"
      />
    </div>
  </div>
</template>

<script>
import ActivityCard from "./ActivityCard.vue";

export default {
  name: "SupervisionDetails",
  components: {
    ActivityCard,
  },
  props: {
    supervision: {
      type: Object,
      default: () => ({}),
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["setVerifiedItem", "openModal", "openImage"],
  data() {
    return {
      isDown: false,
      isDragging: false,
      startX: 0,
      scrollLeft: 0,
    };
  },
  methods: {
    startDrag(e) {
      this.isDown = true;
      this.isDragging = false;
      this.startX = e.pageX - this.$refs.scrollContainer.offsetLeft;
      this.scrollLeft = this.$refs.scrollContainer.scrollLeft;
    },
    stopDrag() {
      this.isDown = false;
    },
    doDrag(e) {
      if (!this.isDown) return;
      e.preventDefault();
      const x = e.pageX - this.$refs.scrollContainer.offsetLeft;
      const walk = x - this.startX;
      if (Math.abs(walk) > 5) {
        this.isDragging = true;
      }
      this.$refs.scrollContainer.scrollLeft = this.scrollLeft - walk;
    },
    handleClick(e) {
      if (this.isDragging) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
  },
};
</script>

<style lang="scss" module>
.description {
  width: 100%;
  max-height: 0;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
  padding: 0;
  background-color: $background;
  &.open {
    padding: 0.75rem 0;
    max-height: 1000px;
  }
  .top {
    display: flex;
    overflow: auto;
    @include scrollbarX;
    padding: 0 0 0.75rem 0;
    margin: 0 0 0.75rem 0;
    border-bottom: 1px solid $gray-34;
    gap: 1rem;
    cursor: grab;
    &.active {
      cursor: grabbing;
      user-select: none;
    }
    .left {
      background-color: $gray;
      flex: 0 0 17.5rem;
      border-radius: 0.75rem;
      color: $t-white;
      font-weight: 700;
      padding: 1rem;
      div {
        padding: 0.75rem 0;
        border-bottom: 1px solid $t-white;
        &:last-child {
          border: none;
        }
      }
    }
  }
}
</style>

